import React, { useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'

import '../Registration/registrationStep1.css'
import RadioBox from '../../components/atoms/RadioBox'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import CheckBox from '../../components/atoms/CheckBox'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { Formik, useFormik } from 'formik'
import { register1Schema } from '../../Utils/Validatior'
import { request } from '../../Utils/Request'
import { useSnackbar } from 'notistack'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import CustomPhone from '../../components/atoms/Inputs/CustomPhone'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import OTPInput from './OtpInput'
import { otpSchema } from '../Registration/register1Schema'
import csc from 'country-state-city'
import { useTranslation } from 'react-i18next'

const OtpVerification = () => {
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const { t } = useTranslation()
    const userRole = searchParams.get('role')
    const isseller = searchParams.get('isseller')

    const { enqueueSnackbar } = useSnackbar()
    // const [userRole] = useState(
    //     new URLSearchParams(window.location.search.substring(1)).get('role'),
    // )
    // const [isseller] = useState(
    //     new URLSearchParams(window.location.search.substring(1)).get('isseller'),
    // )
    const [userDetails, setUserDetails] = useState({
        full_name: '',
        user_name: '',
        email: '',
        password: '',
        role: 'for_my_self',
        terms: false,
    })

    const [otpVerified, setOtpVerified] = useState(false)
    const [userID, setUserID] = useState('')
    const [otp, setOtp] = useState('')

    const formik = useFormik({
        initialValues: {
            password: '',
            confirm_password: '',
        },
        validationSchema: otpSchema(),
        onSubmit: async (values) => {},
    })

    const loginConfimation = () => {
        return (
            <p className="light-white m-0 agree-condition">
                I agree the <span className="terms">terms</span> and &nbsp;
                <span className="conditions">Conditions</span>
            </p>
        )
    }

    const register = async () => {
        try {
            if (!otpVerified) {
                return enqueueSnackbar('Verify your otp code!', {
                    variant: 'error',
                })
            }

            const errors = await formik.validateForm()
            formik.setTouched(errors, true)

            if (Object.keys(errors).length !== 0) {
                return
            }

            const formData = new FormData()
            formData.append('first_name', location?.state?.first_name)
            formData.append('last_name', location?.state?.last_name)
            formData.append('email', location?.state?.email)
            formData.append('phone', location?.state?.phone)
            formData.append('country', location?.state?.country)
            formData.append('state', location?.state?.state)
            formData.append('city', location?.state?.city)
            formData.append('address', location?.state?.address)
            formData.append('zip', location?.state?.zip_code)
            formData.append('new_password', formik.values.password)
            formData.append('confirm_new_password', formik.values.password)
            formData.append('site_id', process.env.REACT_APP_SITE_ID)
            // formData.append('auction_io', '1')
            formData.append('role', location?.state?.role)
            formData.append('user_id', userID)
            formData.append('isseller', location?.state?.isseller)
            formData.append('orgNum', location?.state?.orgNum)

            const res = await request('post', '/updateUserPersonalDetails_carzaar', formData)
            if (res.data.success != 'yes') {
                return enqueueSnackbar(res.data.failedreason, {
                    variant: 'error',
                })
            }
            enqueueSnackbar(res.data.successreason, {
                variant: 'success',
            })

            loginRedirect()
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeRadio = (e) => {
        setUserDetails({
            ...userDetails,
            role: e.target.value,
        })
    }
    const loginRedirect = () => {
        history.push('/login')
    }
    const handleOTPComplete = async (otp) => {
        try {
            enqueueSnackbar('Verifiing your otp!', { variant: 'info' })
            const res = await request(
                'get',
                `/verify_otp_email?email=${encodeURIComponent(
                    location?.state?.email,
                )}&otp=${otp}&site_id=${process.env.REACT_APP_SITE_ID}`,
            )
            if (res.data.status == 'yes') {
                enqueueSnackbar('Your otp verified successfully!', { variant: 'success' })
                setUserID(res.data.message.insertId)
                setOtpVerified(true)
            } else {
                setOtpVerified(false)
                return enqueueSnackbar(res.data.message, { variant: 'error' })
            }
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div className="mobile-signup row m-0">
            <div className=" col-lg-6 col-12 login-content-area">
                <h2 className="text-left light-white">{t('almost_done')}!</h2>
                <p className="text-left text-color-change mt-4">
                    {t('enter_the_verification_code_sent')} <span>{location?.state?.email}</span>
                </p>
                {/* <div className="already-login">
                    <p className="m-0 text-right light-white already-member">Already a Member ?</p>
                    <p className="m-0 text-right login-sign-in light-white" onClick={loginRedirect}>
                        Sign in
                    </p>
                </div> */}
                <div className="signup-area-content">
                    <form className="sign-up-content ">
                        <div className="d-flex align-items-center" style={{ gap: '25px' }}>
                            <OTPInput
                                length={5}
                                onComplete={handleOTPComplete}
                                setParentOtp={setOtp}
                            />
                            <PrimaryButton
                                customClassName="verifyButton"
                                onClick={() => handleOTPComplete(otp)}
                            >
                                {t('verify')}
                            </PrimaryButton>
                        </div>
                        <h4 className="text-left light-white mt-5">{t('set_your_password')}</h4>
                        <div className="row">
                            <CustomInput
                                label={t('password')}
                                type="password"
                                inputClassName="input-login login-user-name col-lg-6"
                                labelClass="login-user-name-label light-white"
                                placeholder={t('password')}
                                onChange={formik.handleChange}
                                name="password"
                                value={formik.values.password}
                                onBlur={formik.handleBlur}
                                helperText={
                                    formik.touched.password && formik.errors.password
                                        ? formik.errors.password
                                        : null
                                }
                                error={formik.touched.password && formik.errors.password}
                            />
                            <CustomInput
                                label={t('confirm_password')}
                                type="password"
                                inputClassName="input-login login-password col-lg-6"
                                labelClass="login-password-label light-white"
                                placeholder={t('confirm_password')}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="confirm_password"
                                value={formik.values.confirm_password}
                                helperText={
                                    formik.touched.confirm_password &&
                                    formik.errors.confirm_password
                                        ? formik.errors.confirm_password
                                        : null
                                }
                                error={
                                    formik.touched.confirm_password &&
                                    formik.errors.confirm_password
                                }
                            />
                        </div>
                        <div className="login-butto">
                            <PrimaryButton
                                customClassName="login-confirm-btn "
                                label={t('create_account')}
                                iconRight={<span className="material-icons">arrow_right_alt</span>}
                                type="button"
                                onClick={register}
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-6 col-12 p-0 borderRight">
                <div className="login-car-image">
                    {/* <div className="garvel-logo">
                        <Link to="/">
                            <img
                                src="/assets/svg/gavel-logo.svg"
                                alt="gavel-logo"
                                className="garvel-logo-image"
                            />
                        </Link>
                    </div> */}
                    <div className="car-container">
                        <div className="car-image-contents">
                            <h4 className="light-black">{t('information_privacy')}</h4>
                            <p className="light-black">{t('your_informationn_safe')}</p>
                        </div>
                    </div>
                    {/* <div className="car-image-contents bottom2">
                        <h4 className="light-black">{t('quick_easy')}</h4>
                        <p className="light-black">{t('set_your_car')}</p>
                    </div>
                    <div className="car-image-contents bottom3">
                        <h4 className="light-black"> {t('do_you_need')}?</h4>
                        <p className="light-black">
                            {t('call_sms')} <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                            {t('via_chat')}
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default OtpVerification
